module.exports = __webpack_public_path__ + "static/media/Jackson St, San Francisco, CA3.05ad4a09.jpg";